/** Shared framer-motion presets — Performance Instrument motion language */
export const STAGGER_MS = 40;
export const FADE_UP_PX = 12;
export const LAYOUT_FADE_UP_PX = 4;
export const LAYOUT_STAGGER_MS = 20;
export const CTA_PRESS_SCALE = 0.97;

export const staggerContainer = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: STAGGER_MS / 1000 },
  },
};

export const staggerItem = {
  hidden: { opacity: 0, y: FADE_UP_PX },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease: [0.16, 1, 0.3, 1] },
  },
};

/** Authenticated app shell — lighter entrance than marketing stagger */
export const layoutStaggerContainer = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: LAYOUT_STAGGER_MS / 1000 },
  },
};

export const layoutStaggerItem = {
  hidden: { opacity: 0, y: LAYOUT_FADE_UP_PX },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.22, ease: [0.16, 1, 0.3, 1] },
  },
};

export const layoutStaggerItemReduced = {
  hidden: { opacity: 1 },
  show: {
    opacity: 1,
    transition: { duration: 0.01 },
  },
};

export const ctaTap = {
  scale: CTA_PRESS_SCALE,
  transition: { type: 'spring', stiffness: 400, damping: 15 },
};
